import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PlatformEnv } from 'src/constants';
import { usePlatformEnvStore } from 'src/stores/platform-integration/platform-env';
import type { GetPlatformResponse, PlatformEnvValues } from 'src/types/platforms';

const platformEnvState = usePlatformEnvStore.getState();

export const usePlatformEnv = () => usePlatformEnvStore((state) => state.platformEnv);

export const usePlatformEnvActions = () => ({
  setPlatformEnv: platformEnvState.setPlatformEnv,
});

export const usePlatformEnvChecker = (platform?: GetPlatformResponse) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const env = searchParams.get('env');
  const [isChecked, setIsChecked] = useState(false);
  const { setPlatformEnv } = usePlatformEnvActions();
  const platformEnv = usePlatformEnv();

  useEffect(() => {
    if (!isChecked && platform) {
      if (env) {
        setPlatformEnv(env as PlatformEnvValues);
        setSearchParams({ env });
      } else if (!platform.hasStaging || platform.brands.some((brand) => brand.env === PlatformEnv.PRODUCTION)) {
        setPlatformEnv(PlatformEnv.PRODUCTION);
        setSearchParams({ env: PlatformEnv.PRODUCTION });
      } else {
        setSearchParams({ env: platformEnv });
      }

      setIsChecked(true);
    }
  }, [env, platform, isChecked, setPlatformEnv, setSearchParams, platformEnv]);

  return isChecked;
};
